import Logo from './Logo'
import styles from './Footer.module.less'
import { useTranslation } from 'react-i18next'
import classnames from 'classnames'
function Index({ history }) {
  const { t, i18n } = useTranslation()
  return (
    <footer className={styles.footer}>
      <div className="mod">
        <Logo className={styles.logo} />
        {
          i18n.language === 'zh' ? (
            <div className={styles.info}>
              <p>
                <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502035516">公安备案号11010502035516</a>
                <a href="https://beian.miit.gov.cn/#/Integrated/index">京ICP备11029981号-10</a>
                <a href="http://p9.qhimg.com/t01761af2b8a4fcb737.jpg">京网文【2021】0038-009号</a>
                <span>京ICP证京B2-20170671</span>
                <a href="http://p8.qhimg.com/t01472b264bd8ef7708.jpg">趣游时代（北京）科技有限公司</a>
              </p>
              <p>抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活 </p>
              <p>商务联系电话：010-68608366-8110 传真：010-68608355</p>
            </div>
          ) : (
            <div className={classnames(styles.info, styles.info_foreign)}>
              <p>
                <a href={`http://about.starworldgames.com/${i18n.language}/privacy-policy.html`} target="_blanck" rel="noopener noreferrer">{t('privateRule')}</a>
                <span>|</span>
                <a href={`http://about.starworldgames.com/${i18n.language}/termsofuse.html`} target="_blanck" rel="noopener noreferrer">{t('userRule')}</a>
              </p>
            </div>
          )
        }

      </div>
    </footer>
  );
}

export default Index;
